"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLoadTracksCallback = void 0;
const tracks_1 = require("../api/tracks");
const ModelStatus_1 = require("../types/ModelStatus");
const ScreenState_1 = require("../types/ScreenState");
function createLoadTracksCallback(tracksModel) {
    let timeout;
    return () => {
        clearTimeout(timeout);
        timeout = setTimeout(async () => {
            tracksModel.playlistId = null;
            tracksModel.status = ModelStatus_1.ModelStatus.Pending;
            tracksModel.onUpdate(ScreenState_1.ScreenState.Tracks);
            tracksModel.setAll(await (0, tracks_1.loadTracks)(tracksModel.filterString));
            tracksModel.status = ModelStatus_1.ModelStatus.Success;
            tracksModel.onUpdate(ScreenState_1.ScreenState.Tracks);
        }, 500);
    };
}
exports.createLoadTracksCallback = createLoadTracksCallback;
